// Indicators the `indicators` catalog makes available for the current asset class
// (GET /api/marketComparison/indicatorCodes). The option lists of the indicator selectors come from
// the locale files and are not aware of the asset class, so a page using them filters the lists
// through this mixin: an indicator that is not available (not computed, not shown) must not be offered.
//
// `validIndicatorCodes` is null until the codes are loaded, and null means "do not filter yet", so the
// selectors do not flash empty before the request completes.

export default {
  data() {
    return {
      validIndicatorCodes: null,
    }
  },
  methods: {
    async loadValidIndicatorCodes() {
      const response = await this.get('/api/marketComparison/indicatorCodes')
      this.validIndicatorCodes = (response && response.codes) || []
    },
    // `options` is a list of `{ value, text }`; returns the ones whose value is an available indicator.
    keepAvailableIndicators(options) {
      if (this.validIndicatorCodes === null) return options
      return options.filter((option) => this.validIndicatorCodes.includes(option.value))
    },
  },
}
